var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm._l(_vm.menuList, function (menuItem, index) {
        return [
          _vm.showMenu(menuItem)
            ? _c(
                "div",
                {
                  key: index,
                  style: {
                    width: "100%",
                    "border-bottom":
                      menuItem.level === 1 ? "2px solid #7A869E" : "",
                    "border-top":
                      menuItem.level != 1 ? "1px solid #7A869E" : "",
                    padding: "5px 0",
                    "padding-left":
                      menuItem.menu_pid === 0 ? "" : menuItem.level * 20 + "px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "font-size": "16px" },
                          attrs: { span: 12 },
                        },
                        [
                          _c(
                            "div",
                            [
                              menuItem.menu_code === "DASHBOARD_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "home-filling" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "FINANCIAL_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "financial" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "TRANSACTION_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "transaction" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "CUSTSER_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "customerService" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "MCH_STORE_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "create_mch_code" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "PAYMENT_LINK_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "payment-link" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "SEND_PAYMENT_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "send-payment" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "PAYMENT_PAGE_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "payment-page" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "DEVELOPER_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "develop" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "SYS_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "system" },
                                  })
                                : _vm._e(),
                              menuItem.menu_code === "QRCODE_KEY"
                                ? _c("svg-icon", {
                                    attrs: { "icon-class": "payment-link" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    menuItem.menu_pid > 0
                                      ? _vm.language == "zh"
                                        ? menuItem.menu_cn_name
                                        : menuItem.menu_en_name
                                      : _vm.language == "zh"
                                      ? menuItem.menu_cn_name
                                      : menuItem.menu_en_name
                                  ) +
                                  " "
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { disabled: _vm.modalFlag === 3 },
                          on: { change: _vm.updateCheckAuth },
                          model: {
                            value: _vm.authCodes,
                            callback: function ($$v) {
                              _vm.authCodes = $$v
                            },
                            expression: "authCodes",
                          },
                        },
                        _vm._l(menuItem.sys_auth_info, function (auth) {
                          return _c(
                            "el-col",
                            { key: auth.auth_code, attrs: { span: 8 } },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass: "checkboxItem",
                                      staticStyle: { margin: "10px" },
                                      attrs: {
                                        label: auth.auth_code,
                                        size: "medium",
                                        disabled:
                                          _vm.lockedAuths.indexOf(
                                            auth.auth_code
                                          ) !== -1 && _vm.modalFlag === 4,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.language == "zh"
                                            ? auth.auth_cn_name
                                            : auth.auth_en_name
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "el-col",
                        [
                          menuItem.children && menuItem.children.length > 0
                            ? [
                                _c("system-mch-menu", {
                                  attrs: {
                                    "menu-list": menuItem.children,
                                    "auth-list": _vm.authCodes,
                                    "locked-code-list": _vm.lockedAuths,
                                    "modal-flag": _vm.modalFlag,
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }